export default __webpack_public_path__ + "static/banner-parents-share-their-best-financial-tips-bbe9cad0aff5f2a5b00ed95f48c5e47d.jpg";